import  Cookies  from 'js-cookie';
import {VuexModule, Module, Action} from 'vuex-module-decorators';
import { initializeApp } from "firebase/app";
import { getAnalytics,logEvent } from "firebase/analytics";
import { v4 as uuidv4 } from 'uuid';
import { Module as Mod } from 'vuex';

export interface LogEventAnalytics {
    name: string;
    data: any
}

@Module({   
    namespaced:true
})
export default class AnalyticsStore  extends VuexModule {   
  
    protected appFirebase: any;

    protected analitycs: any;
    constructor(module:  Mod<any,any>){
        super(module);

        
        const firebaseConfig = {
            apiKey: "AIzaSyCCB4T9aVn_LssQasN73jF9gGCMXbvybyA",
            authDomain: "visualinmueble-91a80.firebaseapp.com",
            projectId: "visualinmueble-91a80",
            storageBucket: "visualinmueble-91a80.appspot.com",
            messagingSenderId: "617385337047",
            appId: "1:617385337047:web:d98883a9fea46724bc9092",
            measurementId: "G-2VQ7CK06S2"
        };


        // Initialize Firebase
        this.appFirebase = initializeApp(firebaseConfig);
        this.analitycs =  getAnalytics(this.appFirebase);
       
    }

    @Action
    public logEvent(payload: LogEventAnalytics): void
    {
        
        let uuidUser = Cookies.get('visualinmueble_uuid_user_shared');
        if(!uuidUser) {
            uuidUser = uuidv4();
            Cookies.set('visualinmueble_uuid_user_shared',uuidUser);
        }
        payload.data = {
            ...payload.data,
            user_cookie: uuidUser,
        }
       
        logEvent(this.analitycs,payload.name,payload.data)
    }  
  
}